import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search } from 'lucide-react';
import { Button } from '../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { useApp } from '../../context/AppContext';
import { COUNTRIES, CATEGORIES } from '../../data/constants';

const selectCls = 'h-11 border-0 bg-transparent hover:bg-[#FAF7F2] focus:ring-0 text-sm font-medium';

export const HeroSearch = () => {
  const { t, lang } = useApp();
  const [q, setQ] = useState('');
  const [cat, setCat] = useState('all');
  const [loc, setLoc] = useState('all');
  const navigate = useNavigate();

  const submit = (e) => {
    e.preventDefault();
    const params = new URLSearchParams();
    if (q) params.set('q', q);
    if (cat !== 'all') params.set('cat', cat);
    if (loc !== 'all') params.set('country', loc);
    navigate(`/marketplace?${params.toString()}`);
  };

  return (
    <form onSubmit={submit} className="mt-8 bg-white rounded-2xl shadow-lg border border-[#EFEAE0] p-2 flex flex-col md:flex-row gap-2" data-testid="hero-search-form">
      <div className="flex-1 flex items-center gap-2 px-3">
        <Search className="w-4 h-4 text-[#7A7468] shrink-0" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder={t('hero.search')} data-testid="hero-search-input" className="flex-1 h-11 bg-transparent outline-none text-sm placeholder:text-[#A8A294]" />
      </div>
      <div className="hidden md:block w-px bg-[#EFEAE0]" />
      <Select value={cat} onValueChange={setCat}>
        <SelectTrigger className={`w-full md:w-44 ${selectCls}`} data-testid="hero-category-select"><SelectValue placeholder={t('mkt.category')} /></SelectTrigger>
        <SelectContent>
          <SelectItem value="all">{t('mkt.category')}</SelectItem>
          {CATEGORIES.map((c) => <SelectItem key={c.id} value={c.id}>{c.name[lang] || c.name.en}</SelectItem>)}
        </SelectContent>
      </Select>
      <div className="hidden md:block w-px bg-[#EFEAE0]" />
      <Select value={loc} onValueChange={setLoc}>
        <SelectTrigger className={`w-full md:w-40 ${selectCls}`} data-testid="hero-country-select"><SelectValue /></SelectTrigger>
        <SelectContent className="max-h-72">
          <SelectItem value="all">{t('hero.everywhere')}</SelectItem>
          {COUNTRIES.map((c) => <SelectItem key={c.code} value={c.code}>{c.flag} {c.name}</SelectItem>)}
        </SelectContent>
      </Select>
      <Button type="submit" size="lg" className="h-11 px-6 bg-[#0F8B5C] hover:bg-[#0A6E47] text-white font-semibold shadow-sm" data-testid="hero-search-submit">
        <Search className="w-4 h-4 mr-2" /> {t('hero.cta.primary')}
      </Button>
    </form>
  );
};
